import { trackAnalyticsEvent } from "./gtmDataLayer";

/**
 * JSON.parse that never throws. On failure, reports `exception_handled`
 * (via trackAnalyticsEvent → GA4) and returns `fallback`.
 *
 * Prefer this for UI / localStorage / query reads. Keep raw JSON.parse
 * (with explicit failure handling) for payment, token refresh, and API bridges.
 *
 * @param {*} input
 * @param {{ source?: string, fallback?: * }} [options]
 */
export function safeJsonParse(input, { source = "safeJsonParse", fallback = null } = {}) {
  if (input === null || input === undefined || input === "") return fallback;
  if (typeof input !== "string") return input;

  try {
    return JSON.parse(input);
  } catch (error) {
    trackAnalyticsEvent("exception_handled", {
      source,
      message: error?.message || "JSON parse failed",
      input_type: typeof input,
      input_length: input.length,
      input_preview: input.slice(0, 120),
    });
    return fallback;
  }
}
